export default {
  account: {
    balance: 'is your account balance',
    generalInfo: {
      label: 'General Info',
      latestPurchases: 'Latest Purchase',
      latestPurchaseSubtitle:
        'The latest purchase you made. You can check for more details in your email.',
      accountBalance: 'Account Balance',
      accountBalanceSubtitle:
        'The balance can be used to purchase products on the checkout.',
      yourAccountBalance: 'Your Account Balance',
    },
    orders: {
      label: 'Orders',
      review: 'Leave a Review',
      downloadPdf: 'Download PDF',
    },
    userInfo: {
      label: 'Account & Info',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      passwordConfirmation: 'Password Confirmation',
    },
    referral: {
      label: 'Refer a friend',
      instructions: {
        title: 'Earn 20 € by inviting a friend',
        list: [
          'Share the code to get a discount on your next purchase',
          'Your friend gets 20 € off on their first purchase, minimum basket of 50€',
          'For every successful referral you get 10€ credit',
        ],
      },
      codeInfo: {
        title: 'Here’s your personal konfetti code',
        shareButton: 'Share now',
      },
      faq: {
        items: [
          {
            question: 'How many friends can I refer?',
            answer: 'There is no limit and you can invite as many as you like!',
          },
          {
            question: 'Is the code only valid for new customers.',
            answer: 'Yes, that is correct.',
          },
          {
            question: 'When do I get my credit?',
            answer:
              'The credit is applied automatically to your account after a successful referral.',
          },
          {
            question: 'Is their a minimum order value for my friend?',
            answer: 'Yes, the minimum order value for your friend is 75 €.',
          },
          {
            question: 'How can I use my credit?',
            answer:
              'Your account credit can be used for future purchases at konfetti and is applied automatically at checkout.',
          },
        ],
      },
    },
    notifications: {
      label: 'Notifications',
      newsletterSubscribe: 'Newsletter Subscribe',
    },
    password: {
      label: 'Password',
    },
  },
}
